import HardwareSerializer from 'eflex/serializers/hardware';

export default class DatalogicSerializer extends HardwareSerializer {}
